<template>
  <div>
    <div class="search-form__filter">
      <!-- active-filter -->
      <!-- <div ref="viewFilter1">
        <IconButton
          class="ml-xl-4 ml-1"
          :class="isAnyValueNotEmpty === true ? 'filter-is-active' : ''"
          :icon="'filter-icon'"
          size="small"
          color="secondary"
        />
      </div> -->
      <!-- <IconButton
        class="ml-xl-4 ml-1"
        :class="isAnyValueNotEmpty === true ? 'filter-is-active' : ''"
        :icon="'filter-icon'"
        size="small"
        color="secondary"
        refButtton="viewFilter1"
      /> -->
      <button
        class="ml-xl-4 ml-1 open-filter-button secondary"
        :class="isAnyValueNotEmpty === true ? 'filter-is-active' : ''"
        ref="viewFilter1"
        @click="viewFilter"
      >
        <!-- <icon name="filter-icon" /> -->
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 5H4L10.4 12.3578V17.4444L13.6 19V12.3578L20 5Z"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span
          v-if="showSelectedCountBadge && selectedFiltersCount > 0"
          class="filter-count-badge"
        >
          {{ selectedFiltersCount }}
        </span>
      </button>

      <div
        v-if="activeFilter"
        :class="[
          { 'search-form__filter-panel': !right_position },
          { 'search-form__filter-panel-right': right_position },
          'filter-block-new',
          { 'overflow-visible': overflowVisible }
        ]"
        style="display: block"
        ref="activeFilte1r"
      >
        <div class="filter-block">
          <div class="search-form__filter-clear-btn" @click="clearFilter">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.8158 4H14.1842V7.5H20.5V11H4.5V7.5H10.8158V4Z"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.5 20H19.5V11H5.5V20Z"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path
                d="M9 20V16"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 20V16"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 20V16"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.44727 20H17.5525"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>נקה הכל</span>
          </div>
          <div class="search-form__filter-panel-title h3">מסנן</div>
          <div v-if="switcerActiv">
            <Switcher
              :ifChecked="switcher"
              switcherText="is active"
              @change="changeSwitcher(switcher)"
            />
          </div>
          <div class="data-filter-block">
            <div
              class="form__row"
              v-if="viewRangeData && this.$route.name !== 'WorkerHoursWorked'"
            >
              <div class="form__field-label">תאריך</div>

              <datepicker
                v-model="startData"
                input-class="form__field-input"
                :format="'dd.MM.yyyy'"
                :language="language['he']"
                name="start"
              />
              <button
                v-if="startData"
                @click="clearStartDate"
                class="clear-button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 348.333 348.333"
                  class="vue-treeselect__x"
                >
                  <path
                    d="M336.559 68.611L231.016 174.165l105.543 105.549c15.699 15.705 15.699 41.145 0 56.85-7.844 7.844-18.128 11.769-28.407 11.769-10.296 0-20.581-3.919-28.419-11.769L174.167 231.003 68.609 336.563c-7.843 7.844-18.128 11.769-28.416 11.769-10.285 0-20.563-3.919-28.413-11.769-15.699-15.698-15.699-41.139 0-56.85l105.54-105.549L11.774 68.611c-15.699-15.699-15.699-41.145 0-56.844 15.696-15.687 41.127-15.687 56.829 0l105.563 105.554L279.721 11.767c15.705-15.687 41.139-15.687 56.832 0 15.705 15.699 15.705 41.145.006 56.844z"
                  ></path>
                </svg>
              </button>
            </div>
            <div
              class="form__row"
              v-if="viewRangeData && this.$route.name !== 'WorkerHoursWorked'"
            >
              <div class="form__field-label">עד תאריך</div>
              <div class="end-data">
                <datepicker
                  v-model="endData"
                  input-class="form__field-input"
                  :format="'dd.MM.yyyy'"
                  :language="language['he']"
                  name="start"
                  :disabled="!startData"
                  :disabled-dates="{ to: startData }"
                />
              </div>
              <button v-if="endData" @click="clearEndDate" class="clear-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 348.333 348.333"
                  class="vue-treeselect__x"
                >
                  <path
                    d="M336.559 68.611L231.016 174.165l105.543 105.549c15.699 15.705 15.699 41.145 0 56.85-7.844 7.844-18.128 11.769-28.407 11.769-10.296 0-20.581-3.919-28.419-11.769L174.167 231.003 68.609 336.563c-7.843 7.844-18.128 11.769-28.416 11.769-10.285 0-20.563-3.919-28.413-11.769-15.699-15.698-15.699-41.139 0-56.85l105.54-105.549L11.774 68.611c-15.699-15.699-15.699-41.145 0-56.844 15.696-15.687 41.127-15.687 56.829 0l105.563 105.554L279.721 11.767c15.705-15.687 41.139-15.687 56.832 0 15.705 15.699 15.705 41.145.006 56.844z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <div class="form__row">
            <div
              class="form__field"
              v-for="(filter, index) in options"
              :key="index"
            >
              <MultiThreeWitdthPaginationForFilter
                v-if="filter.paginated && Array.isArray(filter.options)"
                :disabled="filter.isDisabled && !projectIsSelected"
                :objAllItem="filter.options"
                :title="filter.label"
                :multiply="true"
                :selectedInstArray="selectedInstArray"
                :class="'form__field-select '"
                :viewPagination="true"
                :last_page="filter.last_page"
                :pageList="filter.page_list"
                :totalCount="filter.total_count"
                :valueFilter="filter.value"
                @search="search => searchPaginationSelect(search, filter.slug)"
                :viewCount="filter.view_count"
                @itemsSelected="
                  array => itemsSelected_project(array, filter.slug)
                "
                @clickPagination="
                  search => clickPagination_select_project(search, filter.slug)
                "
              />
              <div
                class="select-new mb-8"
                v-if="!filter.children && filter.searched"
              >
                <div class="label-select">{{ filter.label }}</div>
                <!-- <v-select
                  v-model="options[index].value"
                  :multiple="filter.multi === false ? false : true"
                  :options="filter.options"
                  :filterable="false"
                  @search="onSearchInst"
                  label="label"
                >
                  <template #no-options="">לא נמצאו תוצאות</template></v-select> -->
                <Select2
                  class="
                    form__field-select-mupltiple
                    form__field-select-wrap
                    form-field-custom
                  "
                  style="max-width: 100%"
                  ref="select2"
                  :options="filter.options"
                  v-model="options[index].value"
                  @change="onItemSelected"
                  :settings="{
                    closeOnSelect: false,
                    multiple: true,
                    minimumResultsForSearch: 2,
                    dropdownCssClass:
                      'select2-results-options-multiple select2-filter',

                    ajax: {
                      url: api,
                      dataType: 'json',
                      delay: 800, // Задержка в 300 мс для оптимизации
                      data: function (params) {
                        return {
                          search: params.term,
                          ...params_api
                        };
                      },
                      processResults: function (data) {
                        return {
                          results: data.data.map(item => ({
                            id: item.id,
                            text: item.title
                          }))
                        };
                      }
                    }
                  }"
                />
              </div>
              <custom-three-select
                v-if="
                  !filter.children &&
                  !filter.paginated &&
                  !filter.searched &&
                  !filter.leaf_priority
                "
                :label="filter.label"
                v-model="options[index].value"
                :options="filter.options"
                :multiple="filter.multi === false ? false : true"
              ></custom-three-select>
              <custom-three-select
                v-if="
                  !filter.children &&
                  !filter.paginated &&
                  !filter.searched &&
                  filter.leaf_priority
                "
                :label="filter.label"
                :priority="'LEAF_PRIORITY'"
                :disableBranchNodes="false"
                :flat="false"
                v-model="options[index].value"
                :options="filter.options"
                :multiple="true"
              ></custom-three-select>
              <custom-three-select
                v-if="filter.children && !filter.paginated && !filter.searched"
                :label="filter.label"
                :priority="'LEAF_PRIORITY'"
                :disableBranchNodes="false"
                :flat="false"
                v-model="options[index].value"
                :options="filter.options"
                :multiple="true"
              ></custom-three-select>
            </div>
          </div>
          <div class="form__row sticky-btn">
            <button class="form__field-btn btn btn--blue" @click="filtering()">
              חפש
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from '@/Components/UI/Buttons/IconButton.vue';
import CustomThreeSelect from '@/Components/UI/Form/CustomThreeSelect.vue';
import datepicker from '@/mixins/datepicker';
import { tippy } from 'vue-tippy';
import Switcher from '@/Components/UI/Form/Switcher';
import MultiThreeWitdthPaginationForFilter from '@/Components/UI/Form/MultiThreeWitdthPaginationForFilter.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { api } from 'v-viewer';
export default {
  components: {
    // IconButton,
    // vSelect,
    CustomThreeSelect,
    Switcher,
    MultiThreeWitdthPaginationForFilter
  },
  mixins: [datepicker],

  props: {
    persistDate: {
      type: Boolean,
      default: false
    },
    defaultRange: {
      // {start, end} — применяется в UI только если в localStorage ничего нет; в storage не пишется
      type: Object,
      default: null
    },
    showSelectedCountBadge: {
      type: Boolean,
      default: false
    },
    countDateAsFilter: {
      type: Boolean,
      default: false
    },
    dateStorageKey: {
      type: String,
      default: 'filters:date-range' // можешь переопределить из родителя
    },
    includeRouteInKey: {
      type: Boolean,
      default: false // если нужно раздельно хранить по роутам
    },
    params_api: {
      type: Object,
      default: () => {}
    },
    api: {
      type: String,
      default: () => ''
    },
    right_position: {
      type: Boolean,
      default: false
    },
    filterStady: {
      type: Boolean,
      default: false
    },
    overflowVisible: {
      type: Boolean,
      default: false
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    activeFilter: {
      type: Boolean,
      default: false
    },
    viewRangeData: {
      type: Boolean,
      default: false
    },
    autoFillDates: {
      type: Boolean,
      default: false
    },
    switcerActiv: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedInstArray: null,
      isActiveFilter: true,
      projectIsSelected: false,
      groupsActive: [],
      // filter: {
      //   isActiveFilter: {
      //     name: 'active',
      //     changes: 1
      //   }
      // },
      switcher: false,
      options: [],
      startData: '',
      endData: '',
      isAnyValueNotEmpty: false
      // viewFilter: false
    };
  },
  computed: {
    selectedFiltersCount() {
      const list = Array.isArray(this.options) ? this.options : [];

      const selectCount = list.reduce((acc, f) => {
        const v = f?.value;

        if (Array.isArray(v)) {
          return acc + (v.length > 0 ? 1 : 0);
        }

        if (v === null || v === undefined || v === '') {
          return acc;
        }
        return acc + 1;
      }, 0);

      if (!this.countDateAsFilter) {
        return selectCount;
      }

      const isDateBlockVisible =
        this.viewRangeData && this.$route.name !== 'WorkerHoursWorked';

      if (!isDateBlockVisible) {
        return selectCount;
      }

      const hasAnyDate = !!this.startData || !!this.endData;
      return selectCount + (hasAnyDate ? 1 : 0);
    }
  },
  watch: {
    startData(newVal) {
      if (!this.persistDate || this._suppressDatePersist) {
        return;
      }
      this.saveDateRangeToStorage(newVal, this.endData);
    },
    endData(newVal) {
      if (!this.persistDate || this._suppressDatePersist) {
        return;
      }
      this.saveDateRangeToStorage(this.startData, newVal);
    },
    filterOptions: {
      handler(newVal, oldVal) {
        const updatedOptions = newVal.map(newOption => {
          const existingOption = this.options.find(
            option => option.slug === newOption.slug
          );

          const { value, ...rest } = newOption;
          return {
            ...rest,
            value: existingOption ? existingOption.value : value
          };
        });

        // Проверяем, действительно ли `this.options` нужно обновить
        const isDifferent =
          JSON.stringify(updatedOptions) !== JSON.stringify(this.options);
        if (isDifferent) {
          this.options = updatedOptions;
        }

        // Обновляем флаг `isAnyValueNotEmpty`
        this.isAnyValueNotEmpty = this.options.some(option => {
          if (Array.isArray(option.value)) {
            return option.value.length > 0;
          }
          return !!option.value;
        });
      },
      deep: true
    },
    options: {
      deep: true,
      handler(newOptions) {
        this.$emit('optionsChange', newOptions);
        // this.isAnyValueNotEmpty = newOptions.some(
        //   option => option.value.trim() !== ''
        // );
        const projectFilter = newOptions.find(
          filter => filter.slug === 'projects' || filter.slug === 'projectIds'
        );
        const groupsActive = newOptions.find(
          filter => filter.slug === 'groups_active'
        );
        if (
          groupsActive &&
          Array.isArray(groupsActive.value) &&
          JSON.stringify(groupsActive.value) !==
            JSON.stringify(this.groupsActive)
        ) {
          this.groupsActive = [...groupsActive.value];
          this.$emit('activeSelected', groupsActive.value);
        }
        if (
          projectFilter &&
          Array.isArray(projectFilter.value) &&
          projectFilter.value.length > 0
        ) {
          this.projectIsSelected = true;
          this.$emit('projectSelected', projectFilter.value);
        }
        this.isAnyValueNotEmpty = newOptions.some(option => {
          if (Array.isArray(option.value)) {
            if (option.value.length > 0) {
              return true;
            }
          }
          return false;
        });
      }
    }
  },
  mounted() {
    this.options = this.filterOptions;
    if (this.persistDate) {
      const saved = this.loadDateRangeFromStorage();
      if (saved && (saved.start || saved.end)) {
        // ожидаем строки формата, которые понимает твой datepicker
        this.startData = saved.start || '';
        this.endData = saved.end || '';
      } else if (
        this.defaultRange &&
        (this.defaultRange.start || this.defaultRange.end)
      ) {
        // показываем дефолтный диапазон без записи в localStorage
        this._suppressDatePersist = true;
        this.startData = this.defaultRange.start || '';
        this.endData = this.defaultRange.end || '';
        this.$nextTick(() => {
          this._suppressDatePersist = false;
        });
      }
    }
    // this.tippyInstance = tippy(this.$refs.viewFilter1, {
    //   content: this.$refs.activeFilte1r,
    //   placement: 'bottom-start',
    //   trigger: 'click',
    //   interactive: true,
    //   hideOnClick: true
    // });
  },

  methods: {
    dateStorageResolvedKey() {
      const base = this.dateStorageKey || 'filters:date-range';
      return this.includeRouteInKey && this.$route?.name
        ? `${base}:${this.$route.name}`
        : base;
    },
    saveDateRangeToStorage(start, end) {
      try {
        const key = this.dateStorageResolvedKey();
        if (!start && !end) {
          localStorage.removeItem(key);
          return;
        }
        localStorage.setItem(key, JSON.stringify({ start, end }));
      } catch (_) {
        // молча игнорим, чтобы не ломать UX
      }
    },
    loadDateRangeFromStorage() {
      try {
        const raw = localStorage.getItem(this.dateStorageResolvedKey());
        if (!raw) {
          return null;
        }
        const parsed = JSON.parse(raw);
        // ожидаем объект вида { start: 'dd.MM.yyyy', end: 'dd.MM.yyyy' }
        if (parsed && (parsed.start || parsed.end)) {
          return parsed;
        }
      } catch (_) {}
      return null;
    },
    clearStartDate() {
      this.startData = '';
      if (this.persistDate) {
        this.saveDateRangeToStorage('', this.endData);
      }
    },
    clearEndDate() {
      this.endData = '';
      if (this.persistDate) {
        this.saveDateRangeToStorage(this.startData, '');
      }
    },
    searchPaginationSelect(search, slug) {
      this.$emit('searchPaginationSelect', search, slug);
    },
    onItemSelected() {
      // Найти открытый dropdown Select2
      const dropdown = document.querySelector('.select2-container--open');
      if (dropdown) {
        // Найти поле поиска внутри dropdown
        const searchInput = dropdown.querySelector('.select2-search__field');
        if (searchInput) {
          searchInput.value = ''; // Очистить содержимое поля поиска
          searchInput.dispatchEvent(new Event('input')); // Обновить значение инпута
        }
      }
    },
    onSearchInst(value, array) {
      if (value) {
        this.$emit('searchInst', value);
      }
    },
    itemsSelected_project(array, slug) {
      const index = this.options.findIndex(el => el.slug == slug);
      this.options.splice(index, 1, { ...this.options[index], value: array });
    },
    clickPagination_select_project(slug, search) {
      console.log(slug, 'in filter');
      this.$emit('clickPagination', slug, search);
    },

    changeSwitcher(swic) {
      this.switcher = !this.switcher;
      this.$emit('switcher', this.switcher);
    },
    filtering() {
      // Авто-подстановка дат — только для страниц, явно опт-инувшихся (autoFillDates).
      // Цель: после клика "חפש" в полях datepicker'ов виден ровно тот диапазон,
      // который улетит на бэк — никаких невидимых дефолтов.
      if (this.autoFillDates) {
        if (this.startData && !this.endData) {
          // только "от" → "до" = "от" (тот же день)
          this.endData = new Date(this.startData);
        } else if (!this.startData && this.endData) {
          // только "до" → "от" = "до" (тот же день)
          this.startData = new Date(this.endData);
        } else if (!this.startData && !this.endData) {
          // обе пустые → 1-е … последний день текущего месяца
          const now = new Date();
          this.startData = new Date(now.getFullYear(), now.getMonth(), 1);
          this.endData = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        }
      }

      const data = {
        start: this.startData,
        end: this.endData
      };

      if (this.persistDate) {
        this.saveDateRangeToStorage(this.startData, this.endData);
      }

      if (this.startData && this.endData) {
        this.$emit('filtering', this.options, data);
      } else {
        this.$emit('filtering', this.options);
      }
    },
    viewFilter() {
      this.$emit('viewFilter');
    },
    clearFilter() {
      this.startData = '';
      this.endData = '';
      const newFilters = this.options.map(filter => {
        if (
          filter.value === null ||
          filter.value === 1 ||
          filter.value === 2 ||
          filter.value === undefined
        ) {
          return { ...filter, value: null };
        } else {
          return { ...filter, value: [] };
        }
      });
      this.options = newFilters;

      if (this.persistDate) {
        try {
          localStorage.removeItem(this.__dateStorageResolvedKey());
        } catch (_) {}
      }

      this.$emit('clearFilter');
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .select2-selection__rendered {
  display: flex !important;
}

.form-field-custom {
  .form__field
    .select2-container[dir='rtl']
    .select2-selection--single
    .select2-selection__rendered {
    flex-direction: column !important;
  }
}
</style>
<style>
.select2-container--default
  .select2-selection--multiple
  .select2-selection__rendered {
  display: flex; /* Используем flexbox */
  flex-wrap: wrap; /* Разрешаем перенос элементов на следующую строку */
  gap: 5px; /* Добавляем отступы между элементами */
  max-height: 100px; /* Ограничиваем высоту, если нужно */
  overflow-y: auto; /* Добавляем прокрутку при большом количестве элементов */
}

/* Отдельный элемент выбранного значения */
.select2-container--default
  .select2-selection--multiple
  .select2-selection__choice {
  margin: 2px; /* Внешние отступы */
  white-space: nowrap; /* Предотвращаем перенос текста внутри элемента */
  max-width: 100%; /* Ограничиваем максимальную ширину */
  overflow: hidden; /* Обрезаем текст при нехватке места */
  text-overflow: ellipsis; /* Добавляем многоточие для обрезанного текста */
}
.select2-filter {
  height: 48px !important;
  border-radius: 8px !important;
}

.vs__selected {
  border: none !important;
  background: transparent;
  gap: 2px;
}

.vs__selected:first-of-type {
  padding-top: 10px !important;
}

.vs__dropdown-toggle {
  min-height: 48px !important;
  height: auto !important;
}

.label-select {
  position: absolute;
  z-index: 1;
  font-size: 12px;
  font-weight: 500;
  right: 15px;
  top: 3px;
}

.select-new {
  position: relative;
}

.vs--searchable .vs__dropdown-toggle {
  height: 48px;
  border: 1px solid #e3e7ee;
  border-radius: 8px;
  padding: 0 12px;
  direction: rtl;
  /* padding-left: 9px; */
}

.vs__dropdown-menu {
  direction: rtl;
  text-align: right;
  border-radius: 8px;
}

.vs__dropdown-menu li {
  border-bottom: 1px solid #e3e7ee;
  padding: 6px 12px !important;
}

.vs__dropdown-menu li:hover {
  background: #eef7ff !important;
  color: black;
}

.vs__actions {
  width: 16px;
  height: 16px;
  background-image: url(/images/arrow-drop-down.svg?da3b932…);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  top: 13px;
  position: relative;
  /* left: 3px; */
}

.vs__open-indicator {
  display: none;
  position: relative;
}

.vs__clear {
  fill: #ccc;
  margin-right: -18px;
  margin-bottom: 4px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.vs__clear:hover {
  fill: #e42828 !important;
}
</style>
<style lang="scss" scoped>
.open-filter-button {
  position: relative;
}

.filter-count-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  z-index: 1;
  border-radius: 999px;
  background: #0077ef;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.data-filter-block {
  display: flex;
  gap: 4px;
}

.form__row.sticky-btn {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  background-color: white;
  box-shadow: 0px 19px 0px rgba(255, 255, 255, 1);
}

.form__row {
  position: relative;
}

.clear-button {
  background: none;
  border: none;
  position: absolute;
  top: 32px;
  left: 2px;
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
}

.overflow-visible {
  overflow: visible;
}

.switcher {
  padding-bottom: 12px;
}

.search-form__filter {
  position: relative !important;
}

.open-filter-button {
  border: none;
  width: 40px;
  height: 40px;
  background-color: transparent;
  cursor: pointer;
  display: flex;

  align-items: center;
  justify-content: center;
  transition: 0.3s;
  border-radius: 8px;
  flex-shrink: 0;

  // svg {
  //   stroke: #38455d;
  // }
  &.filter-is-active {
    background: #eef7ff !important;
    stroke: #0077ef !important;
  }

  &.secondary {
    stroke: #38455d;
    background-color: #f7f8fa;

    &:hover {
      background: #eef7ff;
      stroke: #0077ef;
    }

    &:focus {
      background: #eef7ff;
      stroke: #0077ef;
    }

    &:active {
      background: #cfe7ff;
    }

    &:disabled {
      background: #e3e7ee;
      border-color: #e3e7ee;
      stroke: #8e9ebb;
    }
  }
}
@media (max-width: 767px) {
  .filter-count-badge {
    top: -6px;
    right: -3px;
  }
}
</style>
<style>
.end-data .vdp-datepicker {
  direction: ltr !important;
}

.end-data .vdp-datepicker__calendar header {
  direction: rtl;
}

.end-data .form__field-input {
  direction: rtl;
}

.end-data .vdp-datepicker__calendar .flex-rtl {
  direction: rtl;
}

/* .filter-block {
position: relative;
} */
.filter-is-active {
  background: #eef7ff !important;
  stroke: #0077ef !important;
}

.filter-block-new {
  overflow: auto;
  max-height: 60vh;
  min-height: 280px;
  width: 300px !important;
  /* position: relative; */
}

.filter-block-new::-webkit-scrollbar {
  width: 4px;
  background-color: #fff;
  border-radius: 4px;
}

.filter-block-new::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 6px;
}

.filter-block-new::-webkit-scrollbar-track {
  background-color: #f0f0f0;
}
</style>
